<template>
    <div class="documentation-section">
        <div class="filter-section sub-filter">
            <h2>Documents Submitted</h2>
        </div>
        <div class="card document-section">
            <ul class="row">
                <li
                    v-for="(item, index) in documentInfo"
                    :key="index"
                    class="col-md-3"
                >
                    <div class="document-detail" @click="openPopup(index)">
                        <div class="photo-section">
                            <img
                                v-if="!!item.thumbNail"
                                v-authenticated-image="item.thumbNail"
                            />
                            <img
                                v-if="!item.thumbNail"
                                v-authenticated-image="item.fileName"
                            />
                        </div>
                        <div class="upload-detail">
                            <div class="upload-thumbnail">
                                <img
                                    v-if="!!item.thumbNail"
                                    v-authenticated-image="item.thumbNail"
                                />
                                <img
                                    v-if="!item.thumbNail"
                                    v-authenticated-image="item.fileName"
                                />
                            </div>
                            <div class="upload-des">
                                <label>{{ index }}</label>
                                <p>
                                    Uploaded
                                    {{
                                        item.uploadedAt | moment('MMM D, YYYY')
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <document-preview-popup
            :item="documentInfo.address"
        ></document-preview-popup>
        <picture-preview-popup
            :item="documentInfo.picture"
        ></picture-preview-popup>
        <id-card-preview-popup
            :item="documentInfo.cnicFront"
        ></id-card-preview-popup>
        <id-card-preview-popup
            :item="documentInfo.cnicBack"
        ></id-card-preview-popup>
        <id-card-preview-popup
            :item="documentInfo.cnicBack"
        ></id-card-preview-popup>
        <iban-preview-popup :item="documentInfo.iban"></iban-preview-popup>
        <bill-preview-popup :item="documentInfo.address"></bill-preview-popup>
        <relative-preview-popup
            :item="documentInfo.relative"
        ></relative-preview-popup>
        <bill-preview-popup :item="documentInfo.address"></bill-preview-popup>
    </div>
</template>

<script>
import documentPreviewPopup from '@/components/popups/DocumentPreviewPopup.vue'
import picturePreviewPopup from '@/components/popups/PicturePreviewPopup.vue'
import idCardPreviewPopup from '@/components/popups/IDCardPreviewPopup.vue'
import billPreviewPopup from '@/components/popups/BillPreviewPopup.vue'
import ibanPreviewPopup from '@/components/popups/IbanPreviewPopup.vue'
import relativePreviewPopup from '@/components/popups/relativePreviewPopup.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        documentPreviewPopup,
        picturePreviewPopup,
        idCardPreviewPopup,
        billPreviewPopup,
        ibanPreviewPopup,
        relativePreviewPopup,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        documentInfo: {
            type: Object,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        openPopup(popup) {
            switch (popup) {
                case 'picture':
                    this.$bvModal.show('picture-preview-popup')
                    break
                case 'video':
                    this.$bvModal.show('document-preview-popup')
                    break
                case 'identity':
                    this.$bvModal.show('id-card-preview-popup')
                    break
                case 'utility':
                    this.$bvModal.show('bill-preview-popup')
                    break
                case 'iban':
                    this.$bvModal.show('iban-preview-popup')
                    break
                case 'relative':
                    this.$bvModal.show('relative-preview-popup')
                    break
                // case 'relative':
                //     this.$bvModal.show('bill-preview-popup')
                //     break
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>
